<template>
  <div class="kpi_table--column">
    <div class="kpi_table--column--heading">
      <p></p>
    </div>

    <template v-for="(row, key) in kpiRowInfo">
      <div
        v-if="doesUserHaveAccess(row.permissionCheck)"
        :key="key"
        class="kpi_table--column--cell"
      >
        <p class="kpi_table--column--cell--text">{{ row.label }}</p>

        <app-info-tip
          class="kpi_table--column--cell--info"
          :tip="row.description"
          position="is-right"
        ></app-info-tip>
      </div>
    </template>
  </div>
</template>

<script>
import AppInfoTip from "../../../components/app/AppInfoTip";

export default {
  name: "StatsKpiColumnLabel",
  components: {AppInfoTip},
  computed: {
    authUser() {
      return this.$store.getters.authUser;
    },
    kpiRowInfo() {
      return this.$store.getters["statsKpi/kpiRowInfo"];
    },
  },
  methods: {
    doesUserHaveAccess(rowPermissionCheck) {
      // If rowPermissionCheck is null then show row
      if (!rowPermissionCheck) return true;
      // If owner show all row
      if (this.authUser.is_owner) return true;
      // check if user has rowPermissionCheck
      return this.authUser[rowPermissionCheck];
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.kpi_table--column {
  flex: 0 0 $kpiColumnLabel;

  &--cell {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-left: 1px solid $borderDark;
    text-align: center;

    &--text {
      margin-right: 10px;
      font-size: 14px;
    }

    &--info {
      height: 20px;
    }
  }
}
</style>
